import { render, staticRenderFns } from "./DeleteProfileContinue.vue?vue&type=template&id=ff668524&scoped=true"
import script from "./DeleteProfileContinue.vue?vue&type=script&lang=js"
export * from "./DeleteProfileContinue.vue?vue&type=script&lang=js"
import style0 from "./DeleteProfileContinue.vue?vue&type=style&index=0&id=ff668524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff668524",
  null
  
)

export default component.exports